import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, reduce } from "lodash";
import { mapState, mapGetters } from "vuex";
import { SELECTED_BOARD, STATUSES } from "@Broker/@Modules/clients/board/store/board-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfilesFilterDropdown",
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentFilters: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", ["selectedBoardId"])), mapState("AccountStore", ["boardClassicFilters"])), mapGetters("BoardStore", [STATUSES, SELECTED_BOARD])), {}, {
    boardStateFilters() {
      return this.selectedBoardId && this.boardClassicFilters[this.selectedBoardId] || [];
    },
    orderedStatuses() {
      var _context;
      if (!this.SELECTED_BOARD || !this.STATUSES.byId) return [];
      return _mapInstanceProperty(_context = this.SELECTED_BOARD.order).call(_context, order => this.STATUSES.byId[order]);
    }
  }),
  watch: {
    boardStateFilters() {
      this.updateStatusFilter();
    }
  },
  mounted() {
    this.currentFilters = cloneDeep(this.value);
    this.updateStatusFilter();
  },
  methods: {
    isSelected(current) {
      var _context2;
      return _findInstanceProperty(_context2 = this.currentFilters).call(_context2, option => option.value === current);
    },
    handleChange(event, index) {
      const selected = event.target.checked;
      const option = this.options[index];
      if (selected) {
        this.currentFilters.push(option);
      } else {
        var _context3;
        this.currentFilters = _filterInstanceProperty(_context3 = this.currentFilters).call(_context3, filter => filter.value !== option.value);
      }
      this.$emit("input", [...this.currentFilters]);
    },
    updateStatusFilter() {
      var _this$options$;
      if (((_this$options$ = this.options[0]) == null ? void 0 : _this$options$.key) === "status") {
        this.currentFilters = reduce(this.orderedStatuses, (acc, {
          id,
          label
        }) => {
          var _context4;
          if (_includesInstanceProperty(_context4 = this.boardStateFilters).call(_context4, id)) acc.push({
            key: "status",
            name: label,
            value: label,
            id
          });
          return acc;
        }, []);
      }
    }
  }
});